export default () => {
    const containers = document.querySelectorAll('.js-video-block-container')
    if (containers.length < 1) return
        ;
    [...containers].forEach(container => {
        console.log(container)
        const video = container.querySelector('.js-video-block')
        const playButton = container.querySelector('.js-video-block-play')
        const overlay = container.querySelector('.js-video-block-overlay')
        const image = container.querySelector('.js-video-block-image')

        // Video has buffered enough to play
        video.addEventListener('canplay', () => {
            if (video.autoplay) {
                // Fade out the image if video is autoplay
                image.classList.add('hidden')
            }
        })

        // Play video
        if (playButton) {
            playButton.addEventListener('click', () => {
                image.classList.add('hidden')
                overlay.classList.add('hidden')
                playButton.classList.add('hidden')
                video.classList.add('active')

                if (video.nodeName === 'IFRAME') {
                    video.setAttribute('src', video.getAttribute('src') + '?autoplay=1');
                    return;
                }

                video.currentTime = 0
                video.controls = true
                video.muted = false
                video.play()

                // Turn on any subtitles
                for (let i = 0; i < video.textTracks.length; i++) {
                    video.textTracks[i].mode = 'showing'
                }
            })
        }
    })
}

// WEBPACK FOOTER //
// ./src/js/modules/VideoBlock.js
